export default __webpack_public_path__ + "static/4-4eab6a8bd135875ef84bee83e48fb385.jpeg";